// For featured products tabs section

// Check if the component is already defined to prevent duplicate registration
if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Find the parent section using closest() instead of querySelector
      const section = this.closest('.section');
      if (!section) {
        console.error('TabsComponent: Could not find parent section');
        return;
      }

      // Get buttons from this component instance
      const buttonCache = new Map();
      this.buttons = Array.from(this.querySelectorAll('.tabs__button')).map(button => {
        const id = button.getAttribute('data-tab');
        buttonCache.set(id, button);
        return button;
      });
      if (this.buttons.length === 0) {
        console.error('TabsComponent: No buttons found');
        return;
      }

      // Get contents from the section's content wrapper
      const contentWrapper = section.querySelector('.tabs__content-wrapper');
      if (!contentWrapper) {
        console.error('TabsComponent: No content wrapper found');
        return;
      }

      this.contents = Array.from(contentWrapper.querySelectorAll('.tabs__content'));
      if (this.contents.length === 0) {
        console.error('TabsComponent: No content elements found');
        return;
      }
      
      // Add click handlers to each button
      this.buttons.forEach(button => {
        button.addEventListener('click', () => this.handleTabClick(button));
      });

      // Initialize the first tab
      this.handleTabClick(this.buttons[0]);
    }

    handleTabClick(clickedButton) {
      const tabId = clickedButton.getAttribute('data-tab');
      if (!tabId) {
        console.error('TabsComponent: No tab ID found on button');
        return;
      }
      
      // Update button states
      this.buttons.forEach(button => {
        const isSelected = button === clickedButton;
        button.setAttribute('aria-selected', isSelected);
      });
      
      // Update content visibility
      this.contents.forEach(content => {
        const shouldShow = content.id === tabId;
        content.hidden = !shouldShow;
        
        if (shouldShow) {
          // Trigger slider resize if needed
          const slider = content.querySelector('slider-component');
          slider?.dispatchEvent(new CustomEvent('slider:resize'));
        }
      });
    }
  }

  // Register custom elements
  customElements.define('tabs-component', TabsComponent);

  // Export for potential future use with modules
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      TabsComponent
    };
  }
} 